<script setup>
import DownloadBanner from "@/components/banner/DownloadBanner.vue";
import AppBanner from "@/components/layout/AppBanner.vue";
import GlobalBreadcrumbs from "@/components/layout/GlobalBreadcrumbs.vue";
import GlobalFooter from "@/components/layout/GlobalFooter.vue";
import GlobalHeader from "@/components/layout/GlobalHeader.vue";
import NotificationComponent from "@/components/partials/NotificationComponent.vue";
import NotificationDialog from "@/components/partials/NotificationDialog.vue";
import { useLayout2HomeTabsStore } from "@/modules/Layout2/stores/useLayout2HomeTabs.store";
import eventBus from "@/plugins/eventBus";
import { storeToRefs } from "pinia";
import { inject } from "vue";
import { onBeforeMount, onMounted, ref } from "vue";

const layout2Store = useLayout2HomeTabsStore();
const { selectedMainTab } = storeToRefs(layout2Store);

const appleStore = inject('appleStore', "");

// Apple Store Link
const banner = ref(false);

/**
 * Notification Dialog
 */
const notification = ref({
  message: "",
  show: false,
  icon: true,
});

/**
 * Click Close Banner
 * @return {void}
 */
const click_close_banner = () => {
  banner.value = !banner.value;
};

onBeforeMount(() => {
  document.documentElement.style.setProperty("--el-color-primary", "#475467");
  document.documentElement.style.setProperty("--main-bg-color", "#fff");
  document.documentElement.style.setProperty(
    "--el-color-primary-light-3",
    "#667085"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-5",
    "#F2F4F7"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-7",
    "#EAECF0"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-8",
    "#D0D5DD"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-light-9",
    "#EAECF0"
  );
  document.documentElement.style.setProperty(
    "--el-color-primary-dark-2",
    "#98A2B3"
  );
  document.documentElement.style.setProperty("--el-button--primary", "#475467");
});

onBeforeMount(() => {
  selectedMainTab.value = "enrolled";
})

onMounted(() => {
  eventBus.$on("NOTIFICATION_DIALOG", (data) => {
    notification.value = {
      show: true,
      message: data.message,
      icon: data.icon,
    };
  });
});
</script>
<template>
  <AppBanner v-if="$auth.check()" />
  <GlobalHeader v-if="$auth.check()"></GlobalHeader>
  <div class="min-h-screen">
    <GlobalBreadcrumbs v-if="$auth.check()" />
    <router-view :key="$route.fullPath" />
  </div>
  <GlobalFooter v-if="$auth.check()"></GlobalFooter>
  <NotificationDialog
    v-if="notification.show"
    :content="notification.message"
    :icon="notification.icon"
    @close="notification.show = false"
  ></NotificationDialog>

  <DownloadBanner
    v-model="banner"
    :handleCloseBanner="click_close_banner"
    :link="appleStore"
  />
  <NotificationComponent />
</template>

<style lang="css">
</style>
